<template>
  <div class="page">
    <div style>
      <!-- set height if pageHeader is fixed position -->
      <header class="pageHeader white_bg" style="line-height: 30px;">
        <div class="borderLayout" style="height: 30px; padding: 8px 16px;">
          <div class="middleRegion">
            <div class="westRegion" style="width: 60px">
              <!--                            <span class="icon leftAngleBracketIcon floatL"-->
              <!--                              style="margin-top: 3px;"-->
              <!--                              @click="back();"-->
              <!--                            ></span>-->
            </div>
            <div class="centerRegion alignCenter font18r primaryTextColor bold" style="height: 30px; overflow: hidden">
              {{ title }}
            </div>
            <div class="eastRegion font14r alignRight" style="width: 60px">
              <router-link v-show="isVip" class="primaryTextColor bold" to="/myPark">进入园区</router-link>
            </div>
          </div>
        </div>

        <bannerModule ref="bannerModule" type="53" version="4" :isRoundBorder="false" />

        <div class="relative" style="padding: 8px 16px; z-index: 1; top: -18px;">
          <div class="searchBar" style="box-shadow: 0px 2px 8px rgba(179, 179, 179, 0.18);">
            <div style="padding: 10px 0 8px 24px;">
              <div class="clearfix">
                <i class="icon searchIcon size12 fl" style="margin-top: 3px;"></i>
                <input type="text" class="inputbox noBorder noOutline f13 fl" style="margin-left: 3px;"
                  placeholder="搜索园区、职位" v-model="filters.parkNameOrJobName" />
                <div class="alignC f14 bold fr" style="width: 76px; height: 18px; line-height: 18px;
                                color: hsla(40, 100%, 60%, 1); border-left: solid 1px hsla(0, 0%, 44%, 0.09)"
                  @click="onSearch(filters.parkNameOrJobName)">搜索
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>

    <div class="white_bg" style="height: 32px;">
      <div class="flexLayout">
        <div class="flexItem alignC" v-for="filterTypeItem in filterTypeList" :key="filterTypeItem.type">
          <div class="filterTypeItem" :class="{'active' : filterTypeItem.active,
                        opened : filterTypeItem.openStatus}" @click="filterTypeItem.active = true; openFilterDrawer(filterTypeItem);
                         filterTypeItem.openStatus = true">
            {{filterTypeItem.title}}
          </div>
        </div>
      </div>
    </div>

    <div style>
      <div class="organizationList">
        <div class="organizationItem white_bg marginB8" style="padding: 16px 18px; line-height: 32px;"
          v-for="dataItem in dataList" :key="dataItem.id" @click="viewItem(dataItem)">
          <div class="marginB16 clearfix">
            <img class="size32 circle cover fl" :src="dataItem.headImage" />
            <div class="marginL8 f16 fl">
              <router-link class="grey20" :to="'/parkDetail/' + dataItem.parkId">{{ dataItem.name }}
              </router-link>
            </div>
            <div class="fr f16" :style="{color: dataItem.salaryMin ? 'hsla(36, 100%, 57%, 1)' : 'hsla(2, 100%, 61%, 1)'}">
              <span>
                {{ dataItem ? dataItem.salaryMin || "面议" : "面议" }}<span v-if="dataItem.salaryMin">千</span>
              </span>
              <span
                v-if="dataItem.salaryMax && dataItem.salaryMin">&nbsp;-&nbsp;{{ dataItem ? dataItem.salaryMax || "面议" : "面议" }}<span v-if="dataItem.salaryMax">千</span>
              </span>
              <span v-if="dataItem.salaryMin && dataItem.salaryMax">/月</span>
            </div>
          </div>
          <div class="grey20 clearfix">
            <span class="marginR4">在招职位：</span>
            <div class="jobList inline">
              <span class="textLabel" style="margin: 0 4px;"
                v-for="(jobItem, i) in dataItem.jobList.length > 5 ?
							[dataItem.jobList[0],dataItem.jobList[1],dataItem.jobList[2],dataItem.jobList[3],dataItem.jobList[4]] : dataItem.jobList" :key="i" :data-id="jobItem.id">
                {{ jobItem.name }}
              </span>
              <span class="textLabel" v-if="dataItem.jobList.length > 5" style="margin: 0 4px;">...</span>
              <span v-show="dataItem.jobList.length < 1">暂无</span>
            </div>
          </div>
          <div class="descArea bgFAFAFA roundBorder4 font13r"
            style="padding: 9px 0 12px 7px; line-height: 19px; color: hsla(219, 16%, 60%, 1); margin-bottom: 24px;">
            <div style="overflow: hidden">
              <div style="margin-bottom: 14px">
                简介：{{ 69 >= dataItem.introduce.length ? dataItem.introduce : dataItem.introduce.substr(0, 69)+'...' }}
              </div>
              <div class="imageList">
                <img class="imageItem roundBorder4 cover" :src="picItem" v-gallery:organizationDesc
                  v-for="(picItem, picIndex) in dataItem.imgList" :key="picIndex" />
              </div>
            </div>
          </div>

          <div class="f14 clearfix" style="color: hsla(234, 5%, 63%, 1)">
            <div class="fl hiddenOverflow ellipsisOverflowText" style="width: 8em; height: 32px; line-height: 32px;">
              <i class="icon greyLocationIcon size16 fl" style="margin-top: 8px; "></i>
              {{ dataItem.city + dataItem.area }}
            </div>
            <div class="fr">
              <span class="askDiscoverButton" @click.stop.prevent="askDiscover(dataItem)"
                data-click.stop.prevent="askDiscover(dataItem)">求发现</span>
              <span class="deliverButton" @click.stop.prevent="sendResume(dataItem)"
                data-click.stop.prevent="sendResume(dataItem)">投递</span>
            </div>
          </div>
        </div>
        <!-- end .organizationItem -->
      </div>
      <!-- end .organizationList -->

      <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataList.length < 1">
        <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" style="margin-top: 60px;" />
      </div>

      <div class="font12r grey60 alignCenter" style="padding: 26px 0 9px;"
        v-show="status=='ready' && pagination.current == pagination.totalPage" :data-current="pagination.current"
        :data-total="pagination.totalPage || 0">-没有更多啦-
      </div>
    </div>

    <areaSelectorDrawer ref="areaSelectorDrawer" @change="changeArea" />
    <jobSortSelectorDrawer ref="jobSortSelectorDrawer" @change="changeSort" />
    <jobScreeningDrawer ref="jobScreeningDrawer" @change="changeJob" />
    <salaryPackageDrawer ref="salaryPackageDrawer" @change="changeAsk" />

    <editContactInfoDrawer ref="editContactInfoDrawer" :organizationData="editContactInfoDrawer.organizationData" />
    <sendResumeDrawer ref="sendResumeDrawer" :organizationData="sendResumeDrawer.organizationData" />
  </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig from "@/appConfig";

// module
import bannerModule from "@comp/bannerModule";
import editContactInfoDrawer    from "@comp/drawer/editContactInfoDrawer";
import areaSelectorDrawer       from '@comp/drawer/areaSelectorDrawer';
import sendResumeDrawer         from "./drawer/sendResumeDrawer";
import jobScreeningDrawer       from './drawer/jobScreeningDrawer';
import salaryPackageDrawer      from './drawer/salaryPackageDrawer';
import jobSortSelectorDrawer    from './drawer/jobSortSelectorDrawer';

// style
import './filterTypeItem.scss';

// import img-vuer and install
import Vue from "vue";
import gallery from "img-vuer";

Vue.use(gallery, {
  swipeThreshold: 150, // default 100
  isIndexShow: true, // show image index, default true
  useCloseButton: true, // trigger gallery close with close button, default true
  preload: true, // preload images in the same group, default true
  sliderBackgroundColor: "rgba(0,0,0,0.6)",
  sliderZIndex: 1001,
});

// util
import appHelper from "@util/appHelper";
import numberHelper from "@util/numberHelper";
import userUtil from "@comp/shixunApp/userUtil";

const config = {
  apiConfig: {
    list: {
      url: appConfig.apiBaseUrl + "portal/recruit/park/list",
      dataPath: "data.records",
      totalPagePath: "data.pages",
      params: {},
      dataColumnMapping: {
        // userName : 'name''
      },
    },
  },
};

export default {
  name: "humanResourcesIndex",
  extends: shixunPagePart,
  components: {
    bannerModule,
    editContactInfoDrawer,
    sendResumeDrawer,
    areaSelectorDrawer,
    jobScreeningDrawer,
    jobSortSelectorDrawer,
    salaryPackageDrawer
  },
  data () {
    return {
      title: "师讯速聘",
      apiConfig: config.apiConfig,
      enableDataList: true,
      autoLoadDataList: appConfig.mode != "demo",
      isVip: false,
      editContactInfoDrawer: {
        organizationData: null,
      },
      sendResumeDrawer: {
        organizationData: null,
        jobData: null,
      },
      filters: {
        parkNameOrJobName: ''
      },
      filterTypeList: [{
        type: 'area',
        title: '区域',
        active: false,
        openStatus: false
      }, {
        type: 'sort',
        title: '排序',
        active: false,
        openStatus: false
      }, {
        type: 'job',
        title: '职位',
        active: false,
        openStatus: false
      }, {
        type: 'ask',
        title: '要求',
        active: false,
        openStatus: false
      },],
      searchInputbox: {
        column: 'parkNameOrJobName'
      }
    };
  },
  methods: {
    viewItem (dataItem) {
      let path = '/parkDetail/' + dataItem.parkId;
      appHelper.redirect(path);
    },
    back: function () {
      appHelper.redirect("/");
    },
    developing () {
      appHelper.showHint('功能更新中');
    },
    askDiscover (organizationItem = {}) {
      this.editContactInfoDrawer.organizationData = organizationItem;
      this.$refs.editContactInfoDrawer.init(organizationItem);
    },
    sendResume (organizationItem = {}) {
      this.sendResumeDrawer.organizationData = organizationItem;
      this.$refs.sendResumeDrawer.init(organizationItem);
    },
    openFilterDrawer (filterTypeItem) {
      switch (filterTypeItem.type) {
        case 'area':
          this.$refs.areaSelectorDrawer.open();
          break;
        case 'sort':
          this.$refs.jobSortSelectorDrawer.open();
          break;
        case 'job':
          this.$refs.jobScreeningDrawer.open();
          break;
        case 'ask':
          this.$refs.salaryPackageDrawer.open();
          break;

      }
    },
    changeArea (data) {
      let province = data.province;
      let city = data.city;
      let areaList = data.areaList;
      this.filterTypeList[0].active = province ? true : false;
      this.apiConfig.list.params.province = province;
      this.apiConfig.list.params.city = city;
      this.apiConfig.list.params.areaList = areaList.join(',');
      this.reloadDataList();
    },
    changeSort (data) {
      let sortType = data.sortType;
      this.filterTypeList[1].active = sortType ? true : false;
      this.apiConfig.list.params.sortType = sortType;
      this.reloadDataList();
    },
    changeJob (data) {
      this.apiConfig.list.params.jobNames = data;
      this.filterTypeList[2].active = data ? true : false;
      this.reloadDataList();
    },
    changeAsk (data) {
      this.filterTypeList[3].active = data ? true : false;
      if (!data) {
        data = {};
      }
      this.apiConfig.list.params.salaryMin = data.salaryMin;
      this.apiConfig.list.params.salaryMax = data.salaryMax;
      this.reloadDataList();
    }
  },
  mounted () {
    const me = this;

    appHelper.checkLogin((error, result) => {
      if (error) {
        return;
      }
      let vipInfo = JSON.parse(userUtil.createUser(result).vipInfo);
      if (vipInfo.recruit_vip === 1) {
        me.isVip = true;
      }
    });

    if (appConfig.mode == "demo") {
      for (let i = 1; i <= 8; i++) {
        let dataItem = {
          id: i,
          name: "广州市白云区石排村幼儿园",
          headImage: appHelper.getRandomUserHead(),
          desc:
            "石排村小学致力于幼儿教育，幼儿园拥有最强的教" +
            "学资源、教学课程，同时拥有完善的教学系统，对幼师的" +
            "培养有一定的扶持和经验，帮助幼师得到更多的收获...",
          salaryMin: 1,
          salaryMax: 1,
          createTime:
            new Date().getTime() -
            Math.floor(Math.random() * 1000 * 60 * 60 * 24 * 7),
          jobList: [{
            name: '副班老师',
            id: '1'
          }, {
            name: '舞蹈老师',
            id: '2'
          }, {
            name: '语文老师',
            id: '3'
          }, {
            name: '美术老师',
            id: '4'
          }],
          imgList: [],
          city: '广州市',
          area: '白云区',
          address: "石排村",
        };

        for (let j = 0; j < 3; j++) {
          dataItem.imgList.push(appHelper.getRandomCoverImage());
        }

        this.dataList.push(dataItem);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.searchBar {
  height: 36px;
  background: white;
  /*background: #F5F5F5;*/
  border-radius: 18px;

  .searchIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAZCAYAAAArK+5dAAACOUlEQVRIia2Vr28UQRTHV5w4UXmCP6GiAoFANCmChCYgKkgwiAoEAoFAkFCxCQISBJjNdeZ9532nVxJIEBVISEqCOHmi4kRFBeJExYmKEycWsTt7u1f22OvdJCs28+b7eb9mXhTVrDiOW4B/CEcK/JmAEwFTEX8l4EAcP6r2durOL1yqR08E/lzAtME3sFbvNxJOkmTDOv+lKuD/CLxYqwfWun0jLhb4YwHHZTuo/xDHcWuhOJz/XRxyHALcq7OP47hlLfcBjooz4r/VQgB/MvNIPcl2k6iNMR0Bf84cO3p3zUhEnwYDK/zcRPhaNKK/ZpHwbmWzKKjjsKnnNZGEupwWGwD3ikItyHmTJcKXQasLbGUAR4ZuWUU8irIorOg0L/ibjJpdohSOXBWQ6bGfZ+MkAKYCpkZcvA4AEDLCQSCmAqYG+mIdAHHsCpha8CIAxllI/u06AHAML0E/APpZi/rv6wDM3jB/HEVRFFno+5w4SZJkYxVxY7g5a3l9lgEsb5duYLwKAM6HAk+MMZ1iQ8DTfGNsDDdvIi7CeyXvD6tkYKu4II7DhLy1jHiWGn+Z5/6y4n1Y1vF5eQYcOnenibi1+ih0ohWdAtytD9PN3pLQCaq9nfk3nmTbau+BiP8xZz81xm0v9EhEH89Pq/x/kNXKn+VzuSx8LtCrMLP/CzHGdCz00z9Alc86XojwNcm2cW57KUhIBcBda/UAIAFSHLsW+qoyVIJjN4Esu8oQgKO1AwIE4EhEv/4FSm9grvtQ8/kAAAAASUVORK5CYII=');
  }

  .inputbox {
    height: 18px;
    line-height: 18px;
    color: hsla(225, 2%, 62%, 1);
    background: transparent;
  }
}

.organizationList {
  .jobList {
    .textLabel {
      //width: 64px;
      height: 20px;
      line-height: 20px;
      padding: 0 8px;
      border-radius: 12px;
      font-size: 12px;

      &:nth-child(1) {
        background: #fff9ef;
        color: hsla(36, 100%, 57%, 1);
      }

      &:nth-child(2) {
        background: #fff4f3;
        color: hsla(2, 100%, 61%, 1);
      }

      &:nth-child(3) {
        background: #f3f5ff;
        color: hsla(216, 100%, 60%, 1);
      }
    }
  }

  .imageList {
    .imageItem {
      /*width: 103px;*/
      width: 32%;
      height: 67px;
      height: 17.8vw;
      margin-right: 1%;

      //&:last-child {
      //    margin-right: 0;
      //}
    }
  }

  .askDiscoverButton,
  .deliverButton {
    display: inline-block;
    width: 84px;
    height: 28px;
    line-height: 28px;
    border-radius: 20px;
    color: white;
    text-align: center;
    font-size: 16px;
  }

  .askDiscoverButton {
    background: hsla(1, 100%, 73%, 1);
  }

  .deliverButton {
    background: hsla(36, 100%, 70%, 1);
    margin-left: 4px;
  }
}

</style>
